import commonPostTypeConfig from '../../common/postTypes/notification'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'notification',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
